import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import { useHistory, useParams } from "react-router";
import PaymentService from "../../../Services/PaymentService";
import AppointmentService from "../../../Services/AppointmentService";
import { Base64 } from "js-base64";
import { BsPatchCheck } from "react-icons/bs";
import moment from "moment";
import { message } from "antd";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { getLoaderState } from "../../../Redux/actions/CommonActions";
import { useDispatch } from "react-redux";

const PaymentInitiation = () => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [status, setStatus] = useState(null);

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loggedUser = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  useEffect(() => {
    getPaymentStatus();
  }, [params.transactionId]);

  const getPaymentStatus = async () => {
    dispatch(getLoaderState(true));
    try {
      const decodedValues = Base64.decode(params.transactionId);
      const splitValues = decodedValues.split("|");

      const payload = {
        transactionId: splitValues[0],
        patientId: splitValues[1],
        userId: splitValues[2],
        serviceTransId: splitValues[3],
        account_Id: splitValues[4],
        clinic_Id: splitValues[5],
      };

      const result = await PaymentService.getTransactionStatus(payload);

      if (!result?.data) return;

      setStatus(result.data);

    } catch (error) {
      console.error(error);
      message.error("Something went wrong while fetching payment status.");
    } finally {
      dispatch(getLoaderState(false));
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      history.push(APP_ROUTES.DASHBOARD);
    }, 3000);

    return () => clearTimeout(timer);
  }, [status, history]);

  const convertUTCDateLocal = (utcDate, format = "DD/MM/YYYY, HH:mm:ss") => {
    if (!utcDate) return "";
    return moment.utc(utcDate).local().format(format);
  };

  const handleDone = () => {
    history.push(APP_ROUTES.DASHBOARD);
  };

  return (
    <Layouts>
      <div className="min-h-[60vh] flex items-center justify-center">
        {status?.code === "CHECKOUT_ORDER_COMPLETED" && (
          <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full border">
            <div className="text-center">
              <div className="bg-[#E6F2EE] w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center">
                <div className="bg-brand-primaryColor w-7 h-7 rounded-full flex items-center justify-center">
                  <BsPatchCheck className="text-white" />
                </div>
              </div>

              <h2 className="text-xl text-gray-600 font-medium mb-2">
                Payment Successful
              </h2>
              <p className="text-lg font-bold mb-4">{`${loggedUser?.user?.currencyCode || ""} ${status?.paidAmount}`}</p>
            </div>

            <div className="border-t pt-3 space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Transaction ID</span>
                <span className="font-medium">{status?.transactionId}</span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-600">Payment Time</span>
                <span className="font-medium">
                  {convertUTCDateLocal(status?.paidDate)}
                </span>
              </div>
            </div>

            <button
              onClick={handleDone}
              className="mt-5 w-full p-2 bg-brand-primaryColor text-white rounded-lg text-lg font-medium"
            >
              Done
            </button>
          </div>
        )}

        {status?.code === "CHECKOUT_ORDER_FAILED" && (
          <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full border text-center">
            <h2 className="text-xl text-red-600 font-medium mb-2">
              Payment Failed
            </h2>
            <p className="text-lg font-bold mb-2">{`${loggedUser?.user?.currencyCode || ""} ${status?.paidAmount}`}</p>
            <p className="text-gray-500 mb-4">
              {status?.message || "Transaction unsuccessful"}
            </p>

            <button
              onClick={handleDone}
              className="w-full p-2 bg-red-500 text-white rounded-lg"
            >
              Go to Dashboard
            </button>
          </div>
        )}

        {!status?.code && status && (
          <div className="bg-white p-6 rounded-xl shadow-lg max-w-sm w-full border text-center">
            <h2 className="text-xl text-yellow-600 font-medium mb-2">
              Payment Pending
            </h2>
            <p className="text-lg font-bold mb-2">{`${loggedUser?.user?.currencyCode || ""} ${status?.paidAmount}`}</p>
            <p className="text-gray-500 mb-4">
              Please wait while we confirm your payment.
            </p>

            <button
              onClick={handleDone}
              className="w-full p-2 bg-brand-primaryColor text-white rounded-lg"
            >
              Done
            </button>
          </div>
        )}
      </div>
    </Layouts>
  );
};

export default PaymentInitiation;